<template>
    <div>
        <h1>TestComponent</h1>
        <video controls>
          <source src="https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-3_What-is-Bootstrap-And-Why-Mastering-It-Will-Save-You-Hundreds-of-Hours.mp4">
          <p>Votre navigateur ne prend pas en charge les vidéos HTML5.
            Voici <a href="https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-3_What-is-Bootstrap-And-Why-Mastering-It-Will-Save-You-Hundreds-of-Hours.mp4">un lien pour télécharger la vidéo</a>.</p>
        </video>


        <!--[if lt IE 9]><script>document.createElement('video');</script><![endif]-->
        <div class="wp-playlist wp-video-playlist wp-playlist-light">
          <video controls="controls" preload="none" width="618" height="348"></video>
          <div class="wp-playlist-next"></div>
          <div class="wp-playlist-prev"></div>
          <noscript>
            <ol>
              <li>
                <a href='https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1.4_What-is-WordPress-And-Why-You-Should-Care-So-Much-About-It.mp4'>
                1.4_What is WordPress - And Why You Should Care So Much About It
                </a>
              </li>
              <li>
                <a href='https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-1_Welcome-To-The-Course.mp4'>1-1_Welcome To The Course</a>
              </li>
              <li>
                <a href='https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-2_The-Final-WordPress-Website-You-Are-Going-To-Build-In-This-Course.mp4'>
                1-2_The Final WordPress Website You Are Going To Build In This Course
                </a>
              </li>
              <li>
                <a href='https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-3_What-is-Bootstrap-And-Why-Mastering-It-Will-Save-You-Hundreds-of-Hours.mp4'>
                1-3_What is Bootstrap - And Why Mastering It Will Save You Hundreds of Hours
                </a>
              </li>
            </ol>
          </noscript>
          <script type="application/json" class="wp-playlist-script">
          {
            "type" : "video",
            "tracklist" : true,
            "tracknumbers":true,
            "images":true,
            "artists":true,
            "tracks":[
            {
              "src":"https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1.4_What-is-WordPress-And-Why-You-Should-Care-So-Much-About-It.mp4",
              "type":"video/mp4","title":"1.4_What is WordPress - And Why You Should Care So Much About It",
              "caption":"",
              "description":"",
              "meta":{
                "length_formatted":"4:15"},
                "dimensions":{
                  "original":{
                    "width":640,
                    "height":360
                  },
                  "resized":{
                    "width":618,
                    "height":348
                  }
                },
                "image":{
                  "src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,
                  "height":64
                },
                "thumb":{
                  "src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,
                  "height":64
                }
              },
              {
                "src":"https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-1_Welcome-To-The-Course.mp4",
                "type":"video/mp4",
                "title":"1-1_Welcome To The Course",
                "caption":"",
                "description":"",
                "meta":{
                  "length_formatted":"4:29"
                },
                "dimensions":{
                  "original":{
                    "width":640,
                    "height":360
                  },
                  "resized":{
                    "width":618,
                    "height":348
                  }
                },
                "image":{
                  "src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,
                  "height":64
                },
                "thumb":{
                  "src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,"height":64
                }
              },
              {
                "src":"https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-2_The-Final-WordPress-Website-You-Are-Going-To-Build-In-This-Course.mp4",
                "type":"video/mp4",
                "title":"1-2_The Final WordPress Website You Are Going To Build In This Course",
                "caption":"",
                "description":"",
                "meta":{
                  "length_formatted":"4:29"
                },
                "dimensions":{
                  "original":{
                    "width":640,"height":
                  },
                  "resized":{
                    "width":618,
                    "height":348
                  }
                },
                "image":{
                  "src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,
                  "height":64
                },
                "thumb":{
                  "src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,"height":64
                }
              },
              {
                "src":"https://www.bop-lepuy.fr/wp-root/wp-content/uploads/2019/03/1-3_What-is-Bootstrap-And-Why-Mastering-It-Will-Save-You-Hundreds-of-Hours.mp4",
                "type":"video/mp4",
                "title":"1-3_What is Bootstrap - And Why Mastering It Will Save You Hundreds of Hours",
                "caption":"","description":"",
                "meta":{
                  "length_formatted":"5:19"
                },
                "dimensions":{
                  "original":{
                    "width":640,
                    "height":360
                  },
                  "resized":{
                    "width":618,
                    "height":348
                  }
                },
                "image":{
                  "src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,"height":64},"thumb":{"src":"https://www.bop-lepuy.fr/wp-root/wp-includes/images/media/video.png",
                  "width":48,
                  "height":64
                }
              }
            ]
          }
          </script>
        </div>

        <!-- <router-link :to="{name: 'equipe-sf'}">Lien test</router-link> -->
        <app-routes></app-routes>
        <!-- <app-team-training-test></app-team-training-test> -->
        <div class="text-xs-center">
          <v-btn @click="sendTestMsg" color="primary">Submit contact</v-btn>
        </div>

        <app-shared
        :pageCommonData="sharedData"
        :isLoadingData="isLoading"></app-shared>
    </div>
</template>

<script>
import Routes from "./Routes.vue";
import EquipeTrainingTest from "./demo/EquipeTrainingTest.vue";
import PageSharedSections from "./pages/shared/PageSharedSections.vue";

import axios from 'axios';

import RestApiHelper from "../helpers/rest-api-func.js";
import { RestPageIdx, RestCustomPosts, WP_API_ACF_ROOT_URL, WP_API_WP_ROOT_URL } from '../helpers/rest-api-addr.js';


export default {
    data: function() {
        return {
          sharedData: null,
          isLoading : false
        }
    },
    mounted() {
      this.isLoading = true;
      this.sharedData = null;
      let self = this;

      RestApiHelper.requestPageData(WP_API_ACF_ROOT_URL, RestPageIdx.obe)
      .then(r_data => {
        this.sharedData = r_data.data.acf.enable_shared_content;
      })
      .catch(error => {
      })
      .finally(function() {
        self.$nextTick(function() {
          self.isLoading = false;
        })
      });
    },
    methods: {
      extractVideoGallery() {
        var nos = document.getElementsByTagName("noscript")[0];
      },
      createFormData() {
      var form_data = new FormData();
      form_data.append('firstname', 'cheryl');
      form_data.append('name', 'minimoi');
      form_data.append('email', 'test@emial.com');
      form_data.append('subject', 'Un sujet');
      form_data.append('otherSubject', 'Aucun');
      form_data.append('message', 'Ceci est un super message pour moi-même!!!');
      return form_data;
      },
      sendTestMsg() {
        axios.post("http://localhost:8025/contact.php",
        this.createFormData()
        ,
        {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
        .then(response => {
        })
        .catch(error =>  {
        });
      }
    },
    components: {
      "app-routes": Routes,
      "app-team-training-test": EquipeTrainingTest,
      "app-shared": PageSharedSections
    }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/TestComponent.vue